<template>
  <BaseWrapper>
    <div class="space-y-6">
      <PromoActiveList />
      <ShareLinkMemberList />
    </div>
  </BaseWrapper>
</template>
<script>
import PromoActiveList from '../../../components/promo/PromoActiveList.vue';
import ShareLinkMemberList from '../../../components/share-link/ShareLinkMemberList.vue';

export default {
  components: { PromoActiveList, ShareLinkMemberList }
};
</script>
